<div class="not-found">
  <div class="not-found__content">
    <mat-icon>search</mat-icon>
    <span>{{ text }}</span>
  </div>
</div>
